import { http } from '../utils/axios';
import { TPractitionersResponce } from '../types';

class PractitionersService {
  private static instance: PractitionersService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): PractitionersService {
    if (!PractitionersService.instance) {
      PractitionersService.instance = new PractitionersService();
    }

    return PractitionersService.instance;
  }

  getAllPractitioners = async () => {
    const { data } = await http<TPractitionersResponce>({
      url: '/practitioners',
      method: 'GET'
    });

    return data;
  };
}

const instance = PractitionersService.getInstance();

export default instance;
